module.exports = __webpack_public_path__ + "static/media/R4.9603ec7d.jpg";